import { Button, Col, DatePicker, Form, Row, Select, Space } from 'antd';
import { Badge } from 'flowbite-react';
import React from 'react';
import { useLoaderData, useOutletContext } from 'react-router-dom';
import useSettingsAPI from '../apis/settingsAPI';


// const dummy = [
//   {value: '238032', label: 'Road Expense'},
//   {value: 'hiww', label: 'Road Income'}
// ]


const Settings = () => {
  const {journals, settings} = useLoaderData();
  const [form] = Form.useForm();
  const { save, update } = useSettingsAPI();
  
  const handleSave = () => {
    let info = form.getFieldsValue();
    let keys = Object.keys(info);
    let data = [];
    keys.forEach((key, idx) => {
      let obj = {name: key, data: info[key]};
      data.push(obj);
    });
    console.log(info);
    update(data);
  }

  // const filter = (input, option) => (
  //   (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  // )

  return (
    <div className='container mx-auto' style={{maxWidth: '1200px'}}>
      <Button onClick={handleSave}>Save</Button>
      <Form form={form} initialValues={settings} variant='borderless' labelCol={{span: 8}} labelWrap={true} labelAlign='left' className='bg-white '>
        <Row className='mt-5'>
          <Badge className="text-black-900 font-bold bg-gray-100 rounded-none text-md w-full">Default Journal</Badge>
          <Col md={{span: 12}} className='p-3'>
            <Form.Item name={['expense_journal', 'company_journal_id']} label='Company Expense Journal' className='mb-1 font-semibold'>
              <Select options={journals.map(journal => ({value: journal._id, label: journal.name}))} name='vendor_journal_id'/>
            </Form.Item>
          </Col>
          {/* <Col md={{span: 12}} className='p-3'>
            <Form.Item name={['vendor bill', 'vendor_journal_id']} label='Default Journal' className='mb-1 font-semibold'>
              <Select options={[]} name='vendor_journal_id'/>
            </Form.Item>
          </Col> */}
        </Row>

        
      </Form>
    </div>
  )
}

export default Settings;